module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tag', {
    attrs: {
      "type": _vm.value ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.resolveType()))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12952d7d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SpanTrueOrFalse.vue
// module id = 886
// module chunks = 2